const mutations = {
	SET_PUSH_LIST(state, data) {
		state.items = data.content;
		state.totalElements = data.totalElements
		state.totalPages = data.totalPages;
		this.loadingClear = false;
	},
	LOADING_CLEAR(state, value) {
		state.loadingClear = value;
	},
	SET_PAGE_SIZE (state, data) {
		state.size = data
	},
	SET_PUSHLOGS_LIST(state, data) {
		state.items = data.content;
		state.totalElements = data.totalElements;
		state.totalPages = data.totalPages;

		if(data.pageable){
			state.page = data.pageable.pageNumber;
		}
	},
	SET_TOTAL_ELEMENTS(state, data) {
		state.totalElements = data.totalElements
	},
	SET_TOTAL_PAGES(state, data) {
		state.totalPages = data.totalPages
	},
	SET_SEARCH_EMAIL_FILTER(state, data) {
		state.email = data
	},
	SET_REQUEST_URI(state, data) {
		state.requestURI = data
	},
	SET_USER_ID (state, data) {
		state.idUser = data.data
	},
	SET_SEARCH_MESSAGE_FILTER(state, data) {
		state.search_message = data
	},
	SET_ALLOWED_TO_CANCEL(state, data){
		state.allowed_to_cancel = data
	},
	SET_CURRENT_PAGE(state, data) {
		state.current_page = data
	},
	SET_SERVICE(state, data) {
		state.services = data
	},
	SET_LOGS_TO_EDIT(state, data) {
		const logsInfo = JSON.parse(JSON.stringify(data))
		state.logsToEdit = {
			...state.logsToEdit,
			...logsInfo
		}
	},
	SET_DATE (state, data) {
		state.dateSend = data
	},
	UNSET_LOGS_TO_EDIT(state, data) {
		state.logsToEdit = {
			channelType: '',
			dateAdded: '',
			list: '',
			message: '',
			messageType: '',
			moeCampaignName: '',
			name: '',
			produtoSlug: null,
			pushType: null,
			requestJson: '',
			responseJson: '',
			sendTime: null,
			smsContent: '',
			title: '',
			url: null,
		}
	},
}

export default mutations


// WEBPACK FOOTER //
// ./src/store/modules/push_web_logs/mutations.js